let jQuery;

try {
    jQuery = require("jquery");
} catch (e) {}

module.exports = jQuery;
